import { render, staticRenderFns } from "./CartInfoTimeslotCard.vue?vue&type=template&id=616137a6"
import script from "./CartInfoTimeslotCard.vue?vue&type=script&lang=js"
export * from "./CartInfoTimeslotCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports